import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';

const stories = [
    {
        quote:
            'Our company director fell victim to a phishing attack. Thanks to PREVAIL\'s early detection, our managed services team received the alert and immediately blocked access to his account. Any delay in detecting that access could have cost us tens of thousands of dollars in lost research and damage to our reputation.',
        name: 'Director',
        company: 'Medical Research Organization',
        highlight: false,
    },
    {
        quote:
            'The PREVAIL platform provides access to organized data and collaboration that we were unable to get elsewhere — we can provide evidence of data exfiltration or destruction when employees give notice, review best practices across cloud services, and get notified immediately if a client account is compromised.',
        name: 'Principal',
        company: 'Managed IT Services',
        highlight: true,
    },
    {
        quote:
            'PREVAIL detected an unusual amount of activity from a few SharePoint links and notified us that a vendor or customer was likely exploited and attackers were accessing our files. We immediately expired those links and changed policies to better protect our data.',
        name: 'Principal',
        company: 'Architecture Design Firm',
        highlight: false,
    },
];

export default function CustomerSuccessStories() {
    return (
        <Box
            width="100%"
            sx={{
                background: '#242331',
                display: 'grid',
                placeItems: 'center',
                py: 10,
            }}
        >
            <Grid container maxWidth="lg" spacing={3} justifyContent="center" sx={{ px: 2 }}>
                <Grid item size={12} textAlign="center" mb={2}>
                    <Typography
                        variant="overline"
                        color="prevailRed.main"
                        fontWeight="bold"
                        sx={{ letterSpacing: 3, fontSize: '0.9em' }}
                    >
                        CUSTOMER STORIES
                    </Typography>
                    <Typography variant="h3" color="grey.100" fontWeight="bold" mt={1}>
                        What Our Customers Have to Say
                    </Typography>
                </Grid>

                {stories.map(({ quote, name, company, highlight }) => (
                    <Grid item size={{ xs: 12, md: 4 }}  key={company} sx={{ display: 'flex' }}>
                        <Card
                            sx={{
                                background: highlight
                                    ? 'linear-gradient(160deg, #d90000, #8a0000)'
                                    : '#1a1929',
                                border: highlight
                                    ? 'none'
                                    : '1px solid rgba(255,255,255,0.08)',
                                borderRadius: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                            }}
                            elevation={highlight ? 6 : 0}
                        >
                            <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                                <Typography
                                    color={highlight ? 'rgba(255,255,255,0.4)' : 'prevailRed.main'}
                                    sx={{ lineHeight: 0.8, mb: 2, fontSize: '3.5em', fontWeight: 900 }}
                                >
                                    "
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color={highlight ? 'grey.100' : 'grey.300'}
                                    mb={3}
                                    lineHeight={1.8}
                                    sx={{ fontStyle: 'italic', flexGrow: 1 }}
                                >
                                    {quote}
                                </Typography>
                                <Divider
                                    sx={{
                                        borderColor: highlight
                                            ? 'rgba(255,255,255,0.2)'
                                            : 'rgba(255,255,255,0.08)',
                                        mb: 2,
                                    }}
                                />
                                <Typography
                                    variant="body2"
                                    color={highlight ? 'grey.100' : 'grey.200'}
                                    fontWeight="bold"
                                >
                                    {name}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    color={highlight ? 'rgba(255,255,255,0.6)' : 'grey.500'}
                                >
                                    {company}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
